import React, { Component } from 'react';
import { GET_ONE, SelectInput } from 'react-admin';
import dataProvider from '../../../dataProvider';
import { NEW_SEGMENT } from '../constants';

const optionRenderer = (choice) => {
  if (choice.id === NEW_SEGMENT) {
    return <span style={{ color: 'red' }}>{choice.name}</span>;
  }
  const availabilityMessage = `${choice.membersCount} users - ${choice.type}`;
  return choice.membersCount ? `${choice.name} (${availabilityMessage})` : choice.name;
};

class MySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      audienceSegments: [],
    };
  }

  componentDidMount() {
    const { listId } = this.props;
    let audienceSegments = [];
    dataProvider(GET_ONE, 'mailchimpAudiences', { id: listId }).then((res) => {
      audienceSegments = [
        ...[
          { id: 'offerSubscribers', name: 'Selected Offer subscribers' },
          { id: 'newSegment', name: 'Group or new segment' },
        ],
        ...res.data.segments,
      ];
      this.setState({
        // eslint-disable-next-line react/no-unused-state
        audienceSegments,
      });
    });
  }

  render() {
    const {
      audienceSegments,
    } = this.state;

    return (
      <SelectInput
        source="segmentType"
        choices={audienceSegments}
        optionText={optionRenderer}
        disableValue="not_available"
        // onChange={this.handleChange}
      />
    );
  }
}

export default MySelect;



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/Partials/MySelect.js